import React, { useEffect } from "react";
import { createPortal } from "react-dom";

const Message = ({ content, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 2000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "linear-gradient(135deg, rgba(247,147,30,0.95), rgba(255,175,64,0.9))",
        color: "#fff",
        padding: "12px 24px",
        borderRadius: "10px",
        fontSize: "14px",
        fontWeight: 500,
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        zIndex: 1000,
        transition: "opacity 0.3s ease, transform 0.3s ease",
        animation: "fadeSlideIn 0.3s ease",
      }}
    >
      {content}

      <style>
        {`
          @keyframes fadeSlideIn {
            from {
              opacity: 0;
              transform: translate(-50%, -10px);
            }
            to {
              opacity: 1;
              transform: translate(-50%, 0);
            }
          }
        `}
      </style>
    </div>,
    document.body
  );
};

export default Message;
